module.exports = __webpack_public_path__ + "img/home-slide-1.a30d915c.jpg";